// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base-signin {
    display: flex;
    width: 100%;
    height: 100%;
    background: #FFF;
    max-width: 1512px;
}

.base-signin .left-section {
    flex: 1 1;
    width: 100%;
    max-width: 900px;
    padding-top: 208px; /* Reduced padding-top by 100px */
    position: relative;
    order: 1; /* Default order */
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.base-signin .right-section {
    width: 40%;
    height: 100%;
    background: #458BEA;
    display: flex;
    align-items: right;
    justify-content: right;
    order: 1; /* Default order */
}

.base-signin .box {
    margin-bottom: 40px;
    width: 100%;
    max-width: 600px;
}

.base-signin .title {
    font-family: Georgia, serif;
    font-size: 46px;
    font-weight: 700;
    color: #111;
    width: 100%;
}

.base-signin .desc {
    font-size: 25px;
    font-weight: 300;
    color: #6D6D6D;
    width: 100%;
}

.base-signin .error-message {
    color: red;
    margin-bottom: 20px;
    width: 100%;
}

.base-signin .input-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    background: #F8F8F8;
    padding: 10px;
    border-radius: 4px;
    width: 100%;
    max-width: 600px;
}

.base-signin .icon {
    opacity: 0.3;
    margin-right: 10px;
}

.base-signin .input {
    flex-grow: 1;
    border: none;
    background: transparent;
    outline: none;
    font-size: 18px;
    color: #111;
    width: 100%;
}

.base-signin .button {
    display: block;
    margin-top: 20px;
    width: 200px;
    margin-left: auto;
    margin-right: auto;
    text-align: center; /* Center the text within the button */
}

.base-signin .image {
    max-width: 100%;
    height: auto;
    display: none;
}

@media (max-width: 1220px) {
    .base-signin {
        flex-direction: column !important;
    }

    .base-signin .right-section {
        width: 100%;
        height: 100px;
        order: -1; /* Move right-section above left-section */
    }

    .base-signin .left-section {
        order: 2; /* Ensure left-section is below right-section */
        width: 100% !important;
        padding: 28px 5%;
        position: relative;
        max-width: none;
    }

    .base-signin .box,
    .base-signin .input-container,
    .base-signin .button {
        max-width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Signin/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,gBAAgB;IAChB,kBAAkB,EAAE,iCAAiC;IACrD,kBAAkB;IAClB,QAAQ,EAAE,kBAAkB;IAC5B,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ,EAAE,kBAAkB;AAChC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB,EAAE,sCAAsC;AAC9D;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI;QACI,iCAAiC;IACrC;;IAEA;QACI,WAAW;QACX,aAAa;QACb,SAAS,EAAE,0CAA0C;IACzD;;IAEA;QACI,QAAQ,EAAE,+CAA+C;QACzD,sBAAsB;QACtB,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;;;QAGI,eAAe;IACnB;AACJ","sourcesContent":[".base-signin {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    background: #FFF;\n    max-width: 1512px;\n}\n\n.base-signin .left-section {\n    flex: 1;\n    width: 100%;\n    max-width: 900px;\n    padding-top: 208px; /* Reduced padding-top by 100px */\n    position: relative;\n    order: 1; /* Default order */\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.base-signin .right-section {\n    width: 40%;\n    height: 100%;\n    background: #458BEA;\n    display: flex;\n    align-items: right;\n    justify-content: right;\n    order: 1; /* Default order */\n}\n\n.base-signin .box {\n    margin-bottom: 40px;\n    width: 100%;\n    max-width: 600px;\n}\n\n.base-signin .title {\n    font-family: Georgia, serif;\n    font-size: 46px;\n    font-weight: 700;\n    color: #111;\n    width: 100%;\n}\n\n.base-signin .desc {\n    font-size: 25px;\n    font-weight: 300;\n    color: #6D6D6D;\n    width: 100%;\n}\n\n.base-signin .error-message {\n    color: red;\n    margin-bottom: 20px;\n    width: 100%;\n}\n\n.base-signin .input-container {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    background: #F8F8F8;\n    padding: 10px;\n    border-radius: 4px;\n    width: 100%;\n    max-width: 600px;\n}\n\n.base-signin .icon {\n    opacity: 0.3;\n    margin-right: 10px;\n}\n\n.base-signin .input {\n    flex-grow: 1;\n    border: none;\n    background: transparent;\n    outline: none;\n    font-size: 18px;\n    color: #111;\n    width: 100%;\n}\n\n.base-signin .button {\n    display: block;\n    margin-top: 20px;\n    width: 200px;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center; /* Center the text within the button */\n}\n\n.base-signin .image {\n    max-width: 100%;\n    height: auto;\n    display: none;\n}\n\n@media (max-width: 1220px) {\n    .base-signin {\n        flex-direction: column !important;\n    }\n\n    .base-signin .right-section {\n        width: 100%;\n        height: 100px;\n        order: -1; /* Move right-section above left-section */\n    }\n\n    .base-signin .left-section {\n        order: 2; /* Ensure left-section is below right-section */\n        width: 100% !important;\n        padding: 28px 5%;\n        position: relative;\n        max-width: none;\n    }\n\n    .base-signin .box,\n    .base-signin .input-container,\n    .base-signin .button {\n        max-width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
